export default "__VITE_ASSET__k1Y4qE_j__"